var data = {
	"body": "<path d=\"M248 8C111 8 0 119 0 256s111 248 248 248s248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3l-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126c-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z\" fill=\"currentColor\"/>",
	"width": 496,
	"height": 512
};
exports.__esModule = true;
exports.default = data;
